import {
  collection,
  query,
  getCountFromServer,
  where,
  orderBy,
  QueryConstraint
} from '@firebase/firestore';
import { firestoreDb } from 'src/constants';

export async function getUsersLength(params: {
  provider: string;
  value: string;
  filteredField?: string;
  order?: boolean;
}): Promise<number> {
  const { provider, value, filteredField, order } = params;

  let constraints: QueryConstraint[] = [];

  if (provider && value) {
    constraints.push(where(provider, '==', value));
  }

  if (filteredField) {
    constraints.push(orderBy(filteredField, order ? 'asc' : 'desc'));
  }

  const q = query(collection(firestoreDb, 'users'), ...constraints);
  const snapshot = await getCountFromServer(q);

  return snapshot.data().count;
}
